import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { availablePropertyClassTypes, getBdcTimeOptions } from '@tokeet-frontend/channel-content'
import { Rental, SaveForm } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-bdc-create-property-details',
  templateUrl: './bdc-create-property-details.component.html',
  styleUrls: ['./bdc-create-property-details.component.scss'],
})
export class BdcCreatePropertyDetailsComponent {
  @Input() form: FormGroup
  @Input() legalEntityId: string
  @Input() isLoading = false

  @Output() prev = new EventEmitter()
  @Output() next = new EventEmitter<void>()
  @Output() rentalChange = new EventEmitter<Rental>()

  availablePropertyClassTypes = availablePropertyClassTypes
  timeOptions = getBdcTimeOptions()

  rentalCtrl = new FormControl()

  get checkInForm() {
    return this.form.get('check_in') as FormGroup
  }

  onRentalChange([rental]: Rental[]) {
    this.rentalChange.emit(rental)
  }

  @SaveForm()
  onSave(form: FormGroup) {
    this.next.emit()
  }
}
